<template>
  <el-form-item
    :key="item.label"
    :label="item.label"
    label-width="20px">
    <el-row>
      <el-col :span="2">
        <el-input
          v-model="item.labelDisplay"
          style="width: 90%;"></el-input>
      </el-col>
      <el-col :span="20">
        <el-input
          v-if="choiceType === 1"
          v-model="item.content"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4 }"></el-input>
        <upload-with-crop
          v-if="choiceType === 2"
          v-model="item.contentImage"
          :isLt2M="5120"
          :limit="1"
          :showTip="false"
          :autoCropWidth="200"
          :autoCropHeight="60"></upload-with-crop>
      </el-col>
      <el-col :span="2">
        <el-button
          v-if="index === (size - 1)"
          style="margin-left: 5px;"
          type="text"
          @click="delChoiceItem">删除</el-button>
      </el-col>
    </el-row>
  </el-form-item>
</template>
<script>
import UploadWithCrop from '../../../../components/public/upload-with-crop.vue'
export default {
  name: 'QuestionChoiceItem',
  components: { UploadWithCrop },
  props: {
    index: { type: Number, default: -1 },
    value: { type: Object, default() { return {} } },
    choiceType: { type: Number, default: 1 },
    size: { type: Number, default: 1 }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    delChoiceItem() {
      this.$emit('delete', this.index)
    }
  }
}
</script>
